import { render, staticRenderFns } from "./files-list.vue?vue&type=template&id=f84c1d04&scoped=true"
import script from "./files-list.vue?vue&type=script&setup=true&lang=js"
export * from "./files-list.vue?vue&type=script&setup=true&lang=js"
import style0 from "./files-list.vue?vue&type=style&index=0&id=f84c1d04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84c1d04",
  null
  
)

export default component.exports